const style = {
    barIcon: {
        margin: '0px !important',
        color: 'black',
    },
    actionIconContainer: {
        cursor: 'pointer',
        fontSize: 18,
    },
    actionContainer: {
        textAlign: 'center',
    },
    cardBody: { padding: '0px important;' },
    headerButtons: {
        float: 'right',
        fontSize: '16px',
        cursor: 'pointer',
    },
    paginationHeader: {
        marginLeft: 20,
        marginRight: 20,
        width: 200,
        textAlight: 'center',
        fontWeight: '700',
    },
    pageListDropdown: {
        width: 50,
        display: 'inline-block',
    },
    pagination: {
        float: 'right',
        margin: 17,
        padding: '10px !important',
    },
    handle: {
        cursor: 'pointer',
    },
    sortArrow: {
        cursor: 'pointer',
    },
    table: {
        marginBottom: 0,
    },
    selectedRow: {
        backgroundColor: 'blue',
        color: 'white',
    },
};
export default style;
